module.exports = __webpack_public_path__ + "img/image18.aee30a7e.png";